<script setup lang="ts">
/**
 * LIVE — the "Oui" of the Windows authorization prompt (UAC), drawn as a
 * button inside the sentence that asks the pharmacist to click it: a drawn
 * prompt next to the dialog's own buttons read as two more buttons.
 */
</script>

<template>
  <span class="inline-block mx-0.5 px-3 py-0.5 rounded-md border border-[#8a8a8a] bg-white font-semibold text-black leading-snug">Oui</span>
</template>
